// extracted by mini-css-extract-plugin
export default {"container":"_10nmo","button":"A_AR_"};